/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';

export const RedirectLoginPage: React.FC = (): JSX.Element => {
  useEffect(() => {
    window.location.replace('https://saw.com/login');
  }, []);

  return <></>;
};

export default RedirectLoginPage;
